(() => {
  'use strict';

  const VERSION = '12.1.1';
  const ROOT_SELECTOR = '[data-egifts-cross-sell]';
  const DESKTOP_QUERY = '(min-width: 1200px)';
  const DISPLAY_BATCH_SIZE = 12;
  const RANDOM_INITIAL_PAGES = 4;

  // Te kolekcje są wykluczone WYŁĄCZNIE z głównego losowania całego sklepu.
  // Jawna kategoria „Kubki” nadal może korzystać z kubek-z-twoim-zdjeciem.
  const EXCLUDED_COLLECTIONS = new Set([
    'kubki-z-nadrukiem',
    'torba-ze-zdjeciem-i-wlasnym-nadrukiem',
    'bluza-ze-zdjeciem'
  ]);

  // Techniczne/dodatkowe produkty, których nie pokazujemy w cross-sellu.
  const TECHNICAL_HANDLES = new Set([
    'dodatkowy-napis',
    'dodatowe-zdjecie-na-tyl-koszulki',
    'dwie-twarze-bokserki',
    'kubek-z-tym-samym-wzorem',
    'koszulka-z-tym-samym-wzorem',
    'magnes-z-otwieraczem-i-wlasnym-tekstem',
    'magnes-ze-zdjeciem',
    'nadruk-na-calych-bokserkach-przod-tyl',
    'poduszka-z-tym-samym-wzorem',
    'zapakuj-na-prezent',
    'zdjecie-ai'
  ]);

  // Na dole nie ma żadnego dopasowywania do koszyka. Każdy przycisk to po prostu
  // osobna pula produktów. Dla koszulek celowo łączymy kilka kolekcji, żeby obok
  // siebie pojawiały się różne tematy, a nie 12 prawie identycznych produktów.
  const CATEGORY_COLLECTIONS = {
    newest: ['all'],
    hoodie: ['bluza-ze-zdjeciem'],
    funny_shirt: ['smieszne-koszulki-z-nadrukiem'],
    group_trip: ['koszulki-na-wyjazd'],
    vest: ['kamizelki-odblaskowe-z-nadrukiem-smieszne-i-personalizowane-kamizelki-na-prezent'],
    boxers: ['bokserki-z-twarza'],
    panties: ['majtki-z-twarza-i-zdjeciem'],
    socks: ['skarpetki-ze-zdjeciem'],
    mousepad: ['podkladka-pod-mysz-z-twarza'],
    shirt: [
      'smieszne-koszulki-z-nadrukiem',
      'koszulki-z-twoim-zdjeciem',
      'koszulki-i-love-my-boyfriend',
      'koszulki-i-love-my-girlfriend',
      'koszulki-dla-mamy',
      'koszulki-dla-taty',
      'koszulki-dla-rodziny',
      'koszulki-dla-par'
    ],
    mug: ['kubek-z-twoim-zdjeciem'],
    pillow: ['poduszki'],
    pet: ['zwierzaki-prezenty-z-pupilem'],
    bestseller: ['bestsellery']
  };

  if (window.EgiftsCartCrossSell?.version === VERSION) {
    window.EgiftsCartCrossSell.initAll();
    return;
  }

  const liveRoots = new Map();
  const observedRoots = new WeakSet();
  let refreshInFlight = false;
  let refreshQueued = false;
  const productDataCache = new Map();
  const collectionDataCache = new Map();
  let refreshTimer = null;
  let lastFocusedElement = null;
  let excludedProductHandlesPromise = null;
  let placementScheduled = false;
  let crossSellSectionId = '';
  let crossSellSectionHost = null;
  const placementMedia = window.matchMedia(DESKTOP_QUERY);

  const nativeState = {
    active: false,
    opening: false,
    parentProductId: '',
    targetGid: '',
    expiresAt: 0,
    fetchBridge: null,
    suppressRefreshUntil: 0,
    artwork: '',
    artworkTimer: null,
    baselineCustomizations: new Set(),
    targetProductId: '',
    productTypeObserver: null,
    persistPromise: null,
    independentAddUntil: 0,
    xhrBridgeInstalled: false
  };

  const route = (path) => {
    const root = window.Shopify?.routes?.root || '/';
    return `${root}${String(path || '').replace(/^\//, '')}`.replace(/\/{2,}/g, '/');
  };

  const parseJsonScript = (scope, selector, fallback) => {
    try {
      return JSON.parse(scope.querySelector(selector)?.textContent || '');
    } catch (error) {
      return fallback;
    }
  };

  const escapeHtml = (value) => String(value ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');

  const shuffleArray = (items) => {
    const copy = Array.from(items || []);
    for (let index = copy.length - 1; index > 0; index -= 1) {
      const randomIndex = Math.floor(Math.random() * (index + 1));
      [copy[index], copy[randomIndex]] = [copy[randomIndex], copy[index]];
    }
    return copy;
  };

  const uniqueByHandle = (products) => {
    const unique = new Map();
    (products || []).forEach((product) => {
      if (product?.handle && !unique.has(product.handle)) unique.set(product.handle, product);
    });
    return [...unique.values()];
  };

  const placeRoot = (root) => {
    if (!root) return;
    crossSellSectionId = String(root.dataset.sectionId || crossSellSectionId || '');
    if (!crossSellSectionHost || !document.documentElement.contains(crossSellSectionHost)) {
      crossSellSectionHost = root.closest('.shopify-section')
        || document.getElementById(`shopify-section-${crossSellSectionId}`)
        || null;
    }

    const footerGrid = document.querySelector('#main-cart-footer .egifts-cart-footer-grid');
    if (!footerGrid) return;

    const anchor = placementMedia.matches
      ? footerGrid.querySelector('.egifts-gift-wrap-slot')
      : footerGrid.querySelector('.cart__blocks');
    if (!anchor) return;

    if (anchor.nextElementSibling !== root) anchor.insertAdjacentElement('afterend', root);
    root.classList.add('egifts-cross-sell--embedded');
    root.dataset.egiftsCrossSellPlacement = placementMedia.matches ? 'desktop' : 'mobile';
  };

  const schedulePlacement = () => {
    if (placementScheduled) return;
    placementScheduled = true;
    window.requestAnimationFrame(() => {
      placementScheduled = false;
      document.querySelectorAll(ROOT_SELECTOR).forEach(placeRoot);
    });
  };

  const productHandle = (product) => String(
    product?.handle || product?.url?.match(/\/products\/([^/?#]+)/)?.[1] || ''
  ).trim();

  const productImage = (product) => {
    const image = product?.image || product?.featured_image || product?.featuredImage?.url || product?.images?.[0];
    if (!image) return '';
    if (typeof image === 'string') return image;
    return image.src || image.url || '';
  };

  const moneyToCents = (value) => {
    if (typeof value === 'number') return Number.isInteger(value) ? value : Math.round(value * 100);
    const clean = String(value ?? '').replace(/[^0-9,.-]/g, '').replace(',', '.');
    const number = Number(clean);
    if (!Number.isFinite(number)) return 0;
    return clean.includes('.') ? Math.round(number * 100) : Math.round(number);
  };

  const formatMoney = (cents) => {
    try {
      return new Intl.NumberFormat('pl-PL', {
        style: 'currency',
        currency: window.Shopify?.currency?.active || 'PLN',
        minimumFractionDigits: 2
      }).format(Number(cents || 0) / 100);
    } catch (error) {
      return `${(Number(cents || 0) / 100).toFixed(2).replace('.', ',')} zł`;
    }
  };

  const cleanProduct = (product, sourceCollection = '', sourceOrder = 0) => {
    const handle = productHandle(product);
    if (!handle) return null;

    return {
      id: String(product.id || ''),
      productId: String(product.id || ''),
      productGid: String(product.product_gid || product.productGid || (product.id ? `gid://shopify/Product/${product.id}` : '')),
      handle,
      title: String(product.title || ''),
      tags: Array.isArray(product.tags) ? product.tags.join('|') : String(product.tags || ''),
      vendor: String(product.vendor || ''),
      type: String(product.type || product.product_type || ''),
      personalizer: String(product.personalizer || ''),
      variantId: String(product.variant_id || product.variantId || product.variants?.[0]?.id || ''),
      variantCount: Number(product.variant_count ?? product.variantCount ?? product.variants?.length ?? 0),
      availableVariantCount: Number(product.available_variant_count ?? product.availableVariantCount ?? 0),
      directAdd: product.direct_add === true || product.directAdd === true,
      available: product.available !== false,
      image: productImage(product),
      price: moneyToCents(product.price ?? product.price_min),
      compareAtPrice: moneyToCents(product.compare_at_price ?? product.compare_at_price_min),
      url: String(product.url || route(`products/${handle}`)),
      sourceCollection: String(product.collection_handle || sourceCollection || ''),
      sourceOrder
    };
  };

  const fetchCollection = (handle, page = 1, sortBy = 'best-selling') => {
    if (!handle) return Promise.resolve([]);
    const cacheKey = `${handle}:${page}:${sortBy}`;
    if (collectionDataCache.has(cacheKey)) return collectionDataCache.get(cacheKey);

    const params = new URLSearchParams({
      sort_by: sortBy,
      section_id: 'egifts-cross-sell-collection-data',
      page: String(page)
    });

    const request = fetch(`${route(`collections/${handle}`)}?${params.toString()}`, {
      headers: { Accept: 'text/html' },
      cache: 'no-store'
    })
      .then((response) => response.ok ? response.text() : '')
      .then((text) => {
        if (!text) return [];
        const html = new DOMParser().parseFromString(text, 'text/html');
        const data = parseJsonScript(html, '[data-egifts-cross-sell-collection-data]', null);
        const products = Array.isArray(data?.products) ? data.products : [];
        products._egiftsPages = Number(data?.pagination?.pages || 1);
        return products;
      })
      .catch(() => []);

    collectionDataCache.set(cacheKey, request);
    return request;
  };

  const fetchWholeCollection = async (handle, sortBy = 'title-ascending') => {
    const first = await fetchCollection(handle, 1, sortBy);
    const pages = Math.max(1, Number(first?._egiftsPages || 1));
    if (pages <= 1) return first;

    const rest = await Promise.all(
      Array.from({ length: pages - 1 }, (_, index) => fetchCollection(handle, index + 2, sortBy))
    );
    return [first, ...rest].flat();
  };

  const loadExcludedProductHandles = () => {
    if (excludedProductHandlesPromise) return excludedProductHandlesPromise;
    excludedProductHandlesPromise = Promise.all(
      [...EXCLUDED_COLLECTIONS].map((handle) => fetchWholeCollection(handle, 'title-ascending'))
    ).then((groups) => {
      const handles = new Set();
      groups.flat().forEach((product) => {
        const handle = productHandle(product);
        if (handle) handles.add(handle);
      });
      return handles;
    }).catch(() => new Set());
    return excludedProductHandlesPromise;
  };

  const getCartHandles = (root) => {
    const sources = parseJsonScript(root, '[data-egifts-cross-sell-sources]', []);
    return new Set((sources || []).map((item) => String(item?.handle || '')).filter(Boolean));
  };

  const isBlockedCandidate = (product, cartHandles, excludedHandles = null) => {
    if (!product?.handle || !product.available || !product.image || product.price <= 0) return true;
    if (TECHNICAL_HANDLES.has(product.handle)) return true;
    if (cartHandles?.has(product.handle)) return true;
    if (excludedHandles?.has(product.handle)) return true;
    return false;
  };

  const ensurePoolStates = (root) => {
    if (!(root._egiftsPoolStates instanceof Map)) root._egiftsPoolStates = new Map();
    return root._egiftsPoolStates;
  };

  const setPool = (root, key, products, options = {}) => {
    const states = ensurePoolStates(root);
    const previous = states.get(key);
    const state = {
      products: uniqueByHandle(products),
      shown: options.preserveShown && previous?.shown instanceof Set ? previous.shown : new Set(),
      lastBatch: options.preserveShown && previous?.lastBatch instanceof Set ? previous.lastBatch : new Set(),
      mode: options.mode || 'random'
    };
    states.set(key, state);
    if (options.activate !== false) activateCategory(root, key);
    return state;
  };

  const appendToPool = (root, key, products) => {
    const states = ensurePoolStates(root);
    const state = states.get(key);
    if (!state) return;
    state.products = uniqueByHandle([...state.products, ...(products || [])]);
    updateShuffleButton(root);
  };

  const activePoolState = (root) => ensurePoolStates(root).get(root._egiftsActiveCategory || 'random');

  const setStatus = (root, message) => {
    const status = root.querySelector('[data-egifts-cross-sell-status]');
    if (!status) return;
    status.textContent = message || '';
    status.hidden = !message;
  };

  const activateCategory = (root, key) => {
    root._egiftsActiveCategory = key;
    root.querySelectorAll('[data-egifts-cross-sell-category]').forEach((button) => {
      const active = button.dataset.egiftsCrossSellCategory === key;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
    updateShuffleButton(root);
  };

  const updateShuffleButton = (root) => {
    const states = ensurePoolStates(root);
    const randomButton = root.querySelector('[data-egifts-cross-sell-shuffle]');
    const categoryButton = root.querySelector('[data-egifts-cross-sell-category-shuffle]');
    const key = root._egiftsActiveCategory || 'random';
    if (randomButton) randomButton.disabled = !states.get('random')?.products?.length;
    if (categoryButton) {
      categoryButton.disabled = key === 'random' || !states.get(key)?.products?.length;
      categoryButton.hidden = key === 'random';
    }
  };

  const getNextBatch = (state) => {
    if (!state?.products?.length) return [];
    if (!(state.shown instanceof Set)) state.shown = new Set();
    if (!(state.lastBatch instanceof Set)) state.lastBatch = new Set();

    const order = (products) => state.mode === 'ordered' ? Array.from(products) : shuffleArray(products);
    let available = state.products.filter((product) => !state.shown.has(product.handle));
    let batch = [];

    // Najpierw pokazujemy wszystkie produkty, których klient nie widział w bieżącym cyklu.
    // Jeżeli do pełnego zestawu brakuje kilku pozycji, dobieramy je dopiero z nowego cyklu
    // i w pierwszej kolejności omijamy produkty z poprzedniego ekranu.
    if (available.length) {
      batch = order(available).slice(0, DISPLAY_BATCH_SIZE);
    }

    if (batch.length < DISPLAY_BATCH_SIZE && state.products.length > batch.length) {
      const currentHandles = new Set(batch.map((product) => product.handle));
      const previousBatch = new Set(state.lastBatch);
      state.shown.clear();

      let refill = state.products.filter((product) =>
        !currentHandles.has(product.handle) && !previousBatch.has(product.handle)
      );

      if (refill.length < DISPLAY_BATCH_SIZE - batch.length) {
        const refillHandles = new Set(refill.map((product) => product.handle));
        refill = refill.concat(state.products.filter((product) =>
          !currentHandles.has(product.handle) && !refillHandles.has(product.handle)
        ));
      }

      batch = batch.concat(order(refill).slice(0, DISPLAY_BATCH_SIZE - batch.length));
    }

    if (!batch.length) {
      state.shown.clear();
      const previousBatch = new Set(state.lastBatch);
      let freshCycle = state.products.filter((product) => !previousBatch.has(product.handle));
      if (!freshCycle.length) freshCycle = Array.from(state.products);
      batch = order(freshCycle).slice(0, DISPLAY_BATCH_SIZE);
    }

    batch.forEach((product) => state.shown.add(product.handle));
    state.lastBatch = new Set(batch.map((product) => product.handle));
    return batch;
  };

  const renderCards = (root, products) => {
    const list = root.querySelector('[data-egifts-cross-sell-list]');
    if (!list) return;
    const activeKey = root._egiftsActiveCategory || 'random';
    const badge = activeKey === 'random' ? 'ZOBACZ TEŻ' : 'POPULARNE';

    list.innerHTML = (products || []).map((product) => {
      const compare = product.compareAtPrice > product.price
        ? `<s>${escapeHtml(formatMoney(product.compareAtPrice))}</s>`
        : '';
      const ctaLabel = product.directAdd
        ? 'Do koszyka'
        : (product.personalizer === 'teeinblue' || product.personalizer === 'customily' ? 'Personalizuj' : 'Wybierz');

      return `
        <article class="egifts-cross-sell-card">
          <button
            type="button"
            class="egifts-cross-sell-card__button"
            data-egifts-cross-sell-open
            data-product-handle="${escapeHtml(product.handle)}"
            data-product-title="${escapeHtml(product.title)}"
            data-product-url="${escapeHtml(product.url)}"
            data-product-id="${escapeHtml(product.id)}"
            data-product-gid="${escapeHtml(product.productGid)}"
            data-product-personalizer="${escapeHtml(product.personalizer)}"
            data-product-variant-id="${escapeHtml(product.variantId)}"
            data-product-direct-add="${product.directAdd ? 'true' : 'false'}"
            aria-label="${escapeHtml(ctaLabel)}: ${escapeHtml(product.title)}"
          >
            <span class="egifts-cross-sell-card__media">
              <img src="${escapeHtml(product.image)}" alt="" loading="lazy" width="420" height="344">
              <span class="egifts-cross-sell-card__badge">${badge}</span>
            </span>
            <span class="egifts-cross-sell-card__body">
              <strong class="egifts-cross-sell-card__title">${escapeHtml(product.title)}</strong>
              <span class="egifts-cross-sell-card__bottom">
                <span class="egifts-cross-sell-card__price">${compare}${escapeHtml(formatMoney(product.price))}</span>
                <span class="egifts-cross-sell-card__cta" data-egifts-cross-sell-cta>${escapeHtml(ctaLabel)}</span>
              </span>
            </span>
          </button>
        </article>
      `;
    }).join('');
  };

  const renderActivePool = (root, smooth = false) => {
    const state = activePoolState(root);
    if (!state) return;

    const batch = getNextBatch(state);
    if (!batch.length) {
      setStatus(root, 'Nie udało się teraz przygotować propozycji. Spróbuj ponownie.');
      updateShuffleButton(root);
      return;
    }

    renderCards(root, batch);
    const list = root.querySelector('[data-egifts-cross-sell-list]');
    if (list) list.scrollTo({ left: 0, behavior: smooth ? 'smooth' : 'auto' });
    setStatus(root, '');
    updateShuffleButton(root);
  };

  const filterProducts = (products, cartHandles, excludedHandles = null, sourceCollection = '') => {
    return uniqueByHandle((products || []).map((product, index) => cleanProduct(product, sourceCollection, index)))
      .filter((product) => !isBlockedCandidate(product, cartHandles, excludedHandles));
  };

  const prepareRandomStorePool = async (root) => {
    const cartHandles = getCartHandles(root);
    const excludedHandles = await loadExcludedProductHandles();
    const first = await fetchCollection('all', 1, 'title-ascending');
    const totalPages = Math.max(1, Number(first?._egiftsPages || 1));
    const pageOrder = shuffleArray(Array.from({ length: totalPages }, (_, index) => index + 1));
    const initialPages = pageOrder.slice(0, Math.min(RANDOM_INITIAL_PAGES, totalPages));
    const groups = await Promise.all(initialPages.map((page) => fetchCollection('all', page, 'title-ascending')));
    let pool = filterProducts(groups.flat(), cartHandles, excludedHandles, 'all');

    // Gdy bardzo dużo produktów odpadnie przez wykluczenia, dobieramy kolejne strony,
    // żeby pierwsze 12 kart zawsze miało z czego się wylosować.
    let cursor = initialPages.length;
    while (pool.length < DISPLAY_BATCH_SIZE && cursor < pageOrder.length) {
      const page = pageOrder[cursor];
      cursor += 1;
      const products = await fetchCollection('all', page, 'title-ascending');
      pool = uniqueByHandle([...pool, ...filterProducts(products, cartHandles, excludedHandles, 'all')]);
    }

    return {
      pool: shuffleArray(pool),
      remainingPages: pageOrder.slice(cursor),
      cartHandles,
      excludedHandles
    };
  };

  const hydrateRandomStorePool = async (root, state) => {
    const pages = Array.from(state.remainingPages || []);
    if (!pages.length) return;
    root._egiftsRandomHydrating = true;

    for (let index = 0; index < pages.length; index += 3) {
      if (!document.documentElement.contains(root)) break;
      const chunk = pages.slice(index, index + 3);
      const groups = await Promise.all(chunk.map((page) => fetchCollection('all', page, 'title-ascending')));
      const products = filterProducts(groups.flat(), state.cartHandles, state.excludedHandles, 'all');
      appendToPool(root, 'random', shuffleArray(products));
      await new Promise((resolve) => window.setTimeout(resolve, 60));
    }

    root._egiftsRandomHydrating = false;
    updateShuffleButton(root);
  };

  const roundRobinGroups = (groups) => {
    const prepared = shuffleArray(groups.filter((group) => group.length)).map((group) => Array.from(group));
    const result = [];
    let added = true;
    while (added) {
      added = false;
      prepared.forEach((group) => {
        if (!group.length) return;
        result.push(group.shift());
        added = true;
      });
    }
    return uniqueByHandle(result);
  };


  const fetchTopCollectionPool = async (handle, maxPages = 3) => {
    const first = await fetchCollection(handle, 1, 'best-selling');
    const pages = Math.min(Math.max(1, Number(first?._egiftsPages || 1)), Math.max(1, maxPages));
    if (pages <= 1) return first;
    const rest = await Promise.all(
      Array.from({ length: pages - 1 }, (_, index) => fetchCollection(handle, index + 2, 'best-selling'))
    );
    return [first, ...rest].flat();
  };

  const loadCategoryCandidates = async (root, key) => {
    if (key === 'newest') {
      const first = await fetchCollection('all', 1, 'created-descending');
      const pages = Math.min(Math.max(1, Number(first?._egiftsPages || 1)), 3);
      const rest = await Promise.all(Array.from({ length: pages - 1 }, (_, index) =>
        fetchCollection('all', index + 2, 'created-descending')));
      const products = [first, ...rest].flat();
      return filterProducts(products, getCartHandles(root), null, 'all').slice(0, 72);
    }

    const handles = CATEGORY_COLLECTIONS[key] || [];
    if (!handles.length) return [];

    const cartHandles = getCartHandles(root);
    const excludedHandles = key === 'bestseller' ? await loadExcludedProductHandles() : null;
    const groups = await Promise.all(handles.map(async (handle) => {
      const products = await fetchTopCollectionPool(handle, handles.length === 1 ? 3 : 1);
      return filterProducts(products, cartHandles, excludedHandles, handle).slice(0, handles.length === 1 ? 72 : 24);
    }));

    if (handles.length === 1) {
      // Losujemy w obrębie najlepiej sprzedających się produktów danej kategorii.
      return shuffleArray(groups[0] || []);
    }

    // W koszulkach bierzemy naprzemiennie bestsellery z różnych podkolekcji.
    return roundRobinGroups(groups);
  };

  const scrollCarousel = (root, direction) => {
    const list = root?.querySelector('[data-egifts-cross-sell-list]');
    const card = list?.querySelector('.egifts-cross-sell-card');
    if (!list || !card) return;

    const styles = window.getComputedStyle(list);
    const gap = Number.parseFloat(styles.columnGap || styles.gap || '0') || 0;
    const visibleCards = placementMedia.matches ? 4 : 2;
    list.scrollBy({
      left: direction * (card.getBoundingClientRect().width + gap) * visibleCards,
      behavior: 'smooth'
    });
  };

  const setCardLoading = (button, loading, label) => {
    if (!button) return;
    const cta = button.querySelector('[data-egifts-cross-sell-cta]');
    if (cta && !cta.dataset.defaultLabel) cta.dataset.defaultLabel = cta.textContent.trim();
    button.disabled = Boolean(loading);
    button.classList.toggle('is-loading', Boolean(loading));
    if (cta) cta.textContent = label || cta.dataset.defaultLabel || 'Personalizuj';
  };

  const getProductData = (handle) => {
    if (productDataCache.has(handle)) return productDataCache.get(handle);

    const request = fetch(`${route(`products/${handle}`)}?section_id=egifts-cross-sell-product-data`, {
      headers: { Accept: 'text/html' },
      cache: 'no-store'
    })
      .then((response) => {
        if (!response.ok) throw new Error(`Product data HTTP ${response.status}`);
        return response.text();
      })
      .then((text) => {
        const html = new DOMParser().parseFromString(text, 'text/html');
        const data = parseJsonScript(html, '[data-egifts-cross-sell-product-data]', null);
        if (!data?.productId || !data?.handle) throw new Error('Brak danych produktu.');
        return data;
      });

    productDataCache.set(handle, request);
    request.catch(() => productDataCache.delete(handle));
    return request;
  };
  // Produkty wybrane z naszego dużego cross-sellu mają być niezależnymi
  // pozycjami koszyka. Natywny popup Teeinblue może dodać je jako Shopify
  // nested cart line. Relacji nie da się później zmienić, więc usuwamy ją
  // z żądania /cart/add.js zanim trafi do Shopify.
  const armIndependentNativeAdd = () => {
    nativeState.independentAddUntil = Date.now() + 8000;
  };

  const shouldMakeNativeAddIndependent = (url = '') => (
    Date.now() < Number(nativeState.independentAddUntil || 0)
    && /\/cart\/add(?:\.js)?(?:\?|$)/.test(String(url || ''))
  );

  const isParentFieldName = (name = '') => {
    const key = String(name || '');
    return /(^|\[)(parent_line_key|parent_id)(\]|$)/.test(key)
      || key.includes('_parent_customization_id');
  };

  const stripParentFromProperties = (properties) => {
    if (!properties || typeof properties !== 'object' || Array.isArray(properties)) {
      return { value: properties, changed: false };
    }

    const value = { ...properties };
    let changed = false;
    if (Object.prototype.hasOwnProperty.call(value, '_parent_customization_id')) {
      delete value._parent_customization_id;
      changed = true;
    }
    return { value, changed };
  };

  const stripParentFromCartItem = (item) => {
    if (!item || typeof item !== 'object' || Array.isArray(item)) {
      return { value: item, changed: false };
    }

    const value = { ...item };
    let changed = false;

    if (Object.prototype.hasOwnProperty.call(value, 'parent_line_key')) {
      delete value.parent_line_key;
      changed = true;
    }
    if (Object.prototype.hasOwnProperty.call(value, 'parent_id')) {
      delete value.parent_id;
      changed = true;
    }

    const properties = stripParentFromProperties(value.properties);
    if (properties.changed) {
      value.properties = properties.value;
      changed = true;
    }

    return { value, changed };
  };

  const stripParentFromJsonPayload = (payload) => {
    if (!payload || typeof payload !== 'object') return { value: payload, changed: false };

    if (Array.isArray(payload)) {
      let changed = false;
      const value = payload.map((item) => {
        const result = stripParentFromCartItem(item);
        changed = changed || result.changed;
        return result.value;
      });
      return { value, changed };
    }

    const value = { ...payload };
    let changed = false;

    if (Array.isArray(value.items)) {
      value.items = value.items.map((item) => {
        const result = stripParentFromCartItem(item);
        changed = changed || result.changed;
        return result.value;
      });
    } else {
      const result = stripParentFromCartItem(value);
      return result;
    }

    return { value, changed };
  };

  const stripParentFromParams = (params) => {
    if (!params || typeof params.entries !== 'function') return { value: params, changed: false };
    const keys = [];
    for (const [key] of params.entries()) {
      if (isParentFieldName(key)) keys.push(key);
    }
    if (!keys.length) return { value: params, changed: false };
    keys.forEach((key) => params.delete(key));
    return { value: params, changed: true };
  };

  const rewriteIndependentCartAddBody = (body) => {
    if (body == null) return { body, changed: false };

    if (typeof body === 'string') {
      const trimmed = body.trim();
      if (!trimmed) return { body, changed: false };

      try {
        const parsed = JSON.parse(trimmed);
        const result = stripParentFromJsonPayload(parsed);
        return result.changed
          ? { body: JSON.stringify(result.value), changed: true }
          : { body, changed: false };
      } catch (error) {}

      try {
        const params = new URLSearchParams(body);
        const result = stripParentFromParams(params);
        return result.changed
          ? { body: params.toString(), changed: true }
          : { body, changed: false };
      } catch (error) {
        return { body, changed: false };
      }
    }

    if (typeof FormData !== 'undefined' && body instanceof FormData) {
      const clone = new FormData();
      let changed = false;
      for (const [key, value] of body.entries()) {
        if (isParentFieldName(key)) {
          changed = true;
          continue;
        }
        clone.append(key, value);
      }
      return changed ? { body: clone, changed: true } : { body, changed: false };
    }

    if (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) {
      const clone = new URLSearchParams(body.toString());
      const result = stripParentFromParams(clone);
      return { body: result.value, changed: result.changed };
    }

    return { body, changed: false };
  };

  const installNativeXhrBridge = () => {
    if (nativeState.xhrBridgeInstalled || typeof XMLHttpRequest === 'undefined') return;
    nativeState.xhrBridgeInstalled = true;

    const proto = XMLHttpRequest.prototype;
    const originalOpen = proto.open;
    const originalSend = proto.send;

    proto.open = function(method, url, ...rest) {
      this.__egiftsCartAddUrl = String(url || '');
      return originalOpen.call(this, method, url, ...rest);
    };

    proto.send = function(body) {
      const url = String(this.__egiftsCartAddUrl || '');
      if (!shouldMakeNativeAddIndependent(url)) {
        return originalSend.call(this, body);
      }

      const rewritten = rewriteIndependentCartAddBody(body);
      // To jest pierwsze żądanie dodające produkt z naszego popupu. Nawet jeśli
      // SDK nie użyło parent_* w tej wersji, nie przenosimy flagi na kolejne ATC.
      nativeState.independentAddUntil = 0;
      return originalSend.call(this, rewritten.body);
    };
  };

  const deactivateNativeBridge = () => {
    nativeState.active = false;
    nativeState.parentProductId = '';
    nativeState.targetGid = '';
    nativeState.expiresAt = 0;
  };

  const installNativeFetchBridge = () => {
    installNativeXhrBridge();
    if (window.fetch === nativeState.fetchBridge) return;

    const sourceFetch = window.fetch.bind(window);
    const bridge = async (input, init) => {
      const url = typeof input === 'string' ? input : String(input?.url || '');

      if (shouldMakeNativeAddIndependent(url)) {
        let nextInput = input;
        let nextInit = init ? { ...init } : {};
        let rewritten = { body: nextInit.body, changed: false };

        if (Object.prototype.hasOwnProperty.call(nextInit, 'body')) {
          rewritten = rewriteIndependentCartAddBody(nextInit.body);
          if (rewritten.changed) nextInit.body = rewritten.body;
        } else if (typeof Request !== 'undefined' && input instanceof Request) {
          try {
            const originalText = await input.clone().text();
            rewritten = rewriteIndependentCartAddBody(originalText);
            if (rewritten.changed) {
              nextInput = new Request(input, { body: rewritten.body });
            }
          } catch (error) {}
        }

        nativeState.independentAddUntil = 0;
        return sourceFetch(nextInput, nextInit);
      }

      const body = typeof init?.body === 'string' ? init.body : '';
      let shouldOverride = false;

      if (
        nativeState.active &&
        Date.now() < nativeState.expiresAt &&
        nativeState.targetGid &&
        url.includes('/graphql.json') &&
        body.includes('query getProductById') &&
        body.includes('crossSellProductId') &&
        body.includes('crossSellCollectionIdsJson')
      ) {
        try {
          const payload = JSON.parse(body);
          const requestedId = String(payload?.variables?.id || '');
          const expectedId = `gid://shopify/Product/${nativeState.parentProductId}`;
          shouldOverride = !nativeState.parentProductId || requestedId === expectedId;
        } catch (error) {
          shouldOverride = false;
        }
      }

      const response = await sourceFetch(input, init);
      if (!shouldOverride) return response;

      try {
        const json = await response.clone().json();
        if (!json?.data?.product) {
          deactivateNativeBridge();
          return response;
        }

        const targetGid = nativeState.targetGid;
        deactivateNativeBridge();

        json.data.product.crossSellProductId = { value: targetGid };
        json.data.product.crossSellCollectionIdsJson = { value: '[]' };

        const headers = new Headers(response.headers);
        headers.set('content-type', 'application/json; charset=utf-8');
        headers.delete('content-length');
        headers.delete('content-encoding');

        return new Response(JSON.stringify(json), {
          status: response.status,
          statusText: response.statusText,
          headers
        });
      } catch (error) {
        deactivateNativeBridge();
        return response;
      }
    };

    nativeState.fetchBridge = bridge;
    window.fetch = bridge;
  };

  const findNativeTrigger = (launcher) => {
    const wrapper = launcher?.querySelector('.tee-edit-cross-sell-product__wrapper');
    if (!wrapper) return null;
    return wrapper.querySelector('.tee-cross-sell-product-button, button, [role="button"], a[href]')
      || (!wrapper.firstElementChild?.matches('.tee-spinner, .tee-spinner *') ? wrapper.firstElementChild : null);
  };

  const wait = (delay) => new Promise((resolve) => window.setTimeout(resolve, delay));

  const waitForNativeTrigger = async (launcher) => {
    for (let attempt = 0; attempt < 60; attempt += 1) {
      const trigger = findNativeTrigger(launcher);
      if (trigger) return trigger;

      if (attempt === 10 || attempt === 30) {
        nativeState.suppressRefreshUntil = Date.now() + 1500;
        document.dispatchEvent(new Event('shopify-event-cart-ajax'));
      }

      await wait(100);
    }
    return null;
  };

  const nativePopupIsOpen = () => {
    const popup = document.querySelector('.tee-cross-sell-product-popup');
    if (!popup) return false;
    const style = window.getComputedStyle(popup);
    return style.display !== 'none' && style.visibility !== 'hidden' && popup.getClientRects().length > 0;
  };

  const stopNativeProductTypeReveal = () => {
    nativeState.productTypeObserver?.disconnect?.();
    nativeState.productTypeObserver = null;
  };

  const revealNativeProductType = (popup) => {
    if (!popup) return;

    popup.querySelectorAll('.egifts-tee-cross-sell-technical-option').forEach((group) => {
      group.classList.remove('egifts-tee-cross-sell-technical-option');
      group.removeAttribute('aria-hidden');
      group.style.removeProperty('display');
    });

    popup.querySelectorAll('.tee-option').forEach((group) => {
      const heading = String(
        group.querySelector('.tee-option__title, .tee-option-title, legend, [class*="option"][class*="title"]')?.textContent || ''
      )
        .replace(/[Łł]/g, (character) => (character === 'Ł' ? 'L' : 'l'))
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .replace(/\s+/g, ' ')
        .trim();

      if (!heading.includes('rodzaj produktu') && !heading.includes('product type')) return;
      group.classList.remove('egifts-tee-cross-sell-technical-option');
      group.removeAttribute('aria-hidden');
      group.hidden = false;
      group.style.setProperty('display', 'block', 'important');
    });
  };

  const startNativeProductTypeReveal = (popup) => {
    stopNativeProductTypeReveal();
    if (!popup) return;

    revealNativeProductType(popup);
    nativeState.productTypeObserver = new MutationObserver(() => revealNativeProductType(popup));
    nativeState.productTypeObserver.observe(popup, { childList: true, subtree: true });

    [50, 150, 350, 700, 1400, 2600].forEach((delay) => {
      window.setTimeout(() => revealNativeProductType(popup), delay);
    });
    window.setTimeout(stopNativeProductTypeReveal, 30000);
  };

  const teeArtworkHasContent = (svg) => Boolean(
    svg && svg.querySelector('image, path, text, tspan, use, foreignObject, g')
  );

  const serializeVisibleTeeArtwork = () => {
    // Najpierw szukamy warstwy projektu w popupie Teeinblue. Część wersji SDK
    // renderuje jednak SVG podglądu w portalu bezpośrednio pod <body>, poza
    // .tee-cross-sell-product-popup. Dlatego mamy drugi, kontrolowany fallback
    // na widoczne SVG Teeinblue w całym dokumencie.
    //
    // Nie korzystamy z _customization_image jako warstwy nadruku. To jest
    // podgląd całego produktu i jego użycie powoduje efekt "produktu na produkcie".
    const popup = document.querySelector(
      '.tee-cross-sell-product-popup[data-egifts-cross-sell-owned="1"]'
    ) || (nativePopupIsOpen() ? document.querySelector('.tee-cross-sell-product-popup') : null);

    const isOurRenderedClone = (svg) => Boolean(svg.closest(
      '[data-egifts-cart-artwork], [data-egifts-artwork-layer], .egifts-cart-sd-preview, .egifts-cart-sd-panel'
    ));

    const popupCandidates = popup
      ? Array.from(popup.querySelectorAll('svg.tee-mockup-artwork')).filter(teeArtworkHasContent)
      : [];

    const globalCandidates = popupCandidates.length
      ? []
      : Array.from(document.querySelectorAll('svg.tee-mockup-artwork'))
          .filter(teeArtworkHasContent)
          .filter((svg) => !isOurRenderedClone(svg));

    const allCandidates = popupCandidates.length ? popupCandidates : globalCandidates;
    if (!allCandidates.length) return '';

    let candidates = allCandidates.filter((svg) => {
      const style = window.getComputedStyle(svg);
      const rect = svg.getBoundingClientRect();
      return style.display !== 'none' && style.visibility !== 'hidden' && rect.width > 0 && rect.height > 0;
    });
    if (!candidates.length) candidates = allCandidates;
    if (!candidates.length) return '';

    candidates.sort((a, b) => {
      const first = a.getBoundingClientRect();
      const second = b.getBoundingClientRect();
      return second.width * second.height - first.width * first.height;
    });

    const source = candidates[0];
    const clone = source.cloneNode(true);
    clone.querySelectorAll('script').forEach((node) => node.remove());
    [clone, ...clone.querySelectorAll('*')].forEach((node) => {
      Array.from(node.attributes || []).forEach((attribute) => {
        if (/^on/i.test(attribute.name)) node.removeAttribute(attribute.name);
      });
    });

    if (!clone.getAttribute('viewBox')) {
      try {
        const box = source.getBBox();
        if (box.width > 0 && box.height > 0) {
          clone.setAttribute('viewBox', `${box.x} ${box.y} ${box.width} ${box.height}`);
        }
      } catch (error) {}
    }

    clone.removeAttribute('width');
    clone.removeAttribute('height');
    clone.setAttribute('preserveAspectRatio', 'xMidYMid meet');

    try {
      return new XMLSerializer().serializeToString(clone);
    } catch (error) {
      return '';
    }
  };

  const captureNativeArtworkNow = () => {
    const artwork = serializeVisibleTeeArtwork();
    if (artwork) nativeState.artwork = artwork;
    return artwork;
  };

  const stopNativeArtworkCapture = () => {
    if (nativeState.artworkTimer) {
      window.clearInterval(nativeState.artworkTimer);
      nativeState.artworkTimer = null;
    }
  };

  const resetNativeArtworkState = () => {
    stopNativeArtworkCapture();
    nativeState.artwork = '';
    nativeState.targetProductId = '';
    nativeState.baselineCustomizations = new Set();
  };

  const startNativeArtworkCapture = (baselineCart, productData) => {
    stopNativeArtworkCapture();
    nativeState.artwork = '';
    nativeState.targetProductId = String(productData?.productId || '').replace(/\D/g, '');
    nativeState.baselineCustomizations = new Set(
      (baselineCart?.items || [])
        .map((item) => String(item?.properties?._customization_id || ''))
        .filter(Boolean)
    );

    captureNativeArtworkNow();
    nativeState.artworkTimer = window.setInterval(captureNativeArtworkNow, 120);
    window.setTimeout(resetNativeArtworkState, 180000);
  };

  const persistNativeArtworkCore = async () => {
    if (!nativeState.artworkTimer && !nativeState.targetProductId) return false;

    // Ostatnia próba pobrania projektu zanim popup zostanie zamknięty przez SDK.
    const finalArtwork = serializeVisibleTeeArtwork();
    if (finalArtwork) nativeState.artwork = finalArtwork;

    // Nie polegamy na jednym konkretnym evencie Teeinblue. Polling koszyka
    // działa również wtedy, gdy dana wersja SDK emituje inny event po dodaniu.
    for (let attempt = 0; attempt < 60; attempt += 1) {
      try {
        const cart = await fetchCart();
        const newItems = (cart?.items || []).filter((candidate) => {
          const customizationId = String(candidate?.properties?._customization_id || '');
          return customizationId
            && !nativeState.baselineCustomizations.has(customizationId);
        });
        const item = newItems.find((candidate) => {
          const productId = String(candidate?.product_id || '').replace(/\D/g, '');
          return !nativeState.targetProductId || productId === nativeState.targetProductId;
        }) || newItems[0];

        const customizationId = String(item?.properties?._customization_id || '');
        const artwork = nativeState.artwork || captureNativeArtworkNow();
        if (customizationId && artwork) {
          try {
            window.localStorage.setItem(`egifts-sd-artwork:${customizationId}`, artwork);
          } catch (error) {}
          resetNativeArtworkState();
          window.EgiftsSameDesignCartV81?.initAll?.();
          return true;
        }
      } catch (error) {
        // Koszyk i customization_id mogą pojawić się z niewielkim opóźnieniem.
      }
      await wait(120);
    }

    resetNativeArtworkState();
    return false;
  };

  const persistNativeArtwork = () => {
    if (nativeState.persistPromise) return nativeState.persistPromise;

    nativeState.persistPromise = persistNativeArtworkCore()
      .finally(() => {
        nativeState.persistPromise = null;
      });

    return nativeState.persistPromise;
  };

  const persistNativeArtworkAndRefresh = () => {
    persistNativeArtwork().then((saved) => {
      if (saved) {
        rememberScroll();
        window.setTimeout(() => window.location.reload(), 350);
        return;
      }
      scheduleRefresh(900);
    });
  };


  const fetchCart = async () => {
    const response = await fetch(route('cart.js'), {
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      cache: 'no-store'
    });
    if (!response.ok) throw new Error(`Cart HTTP ${response.status}`);
    return response.json();
  };

  const rememberScroll = () => {
    try {
      window.sessionStorage.setItem('egifts-cross-sell-scroll', String(window.scrollY || 0));
    } catch (error) {}
  };

  const addDirectlyToCart = async (root, button, productData) => {
    const variantId = String(productData?.variantId || '');
    if (!variantId) throw new Error('Ten produkt wymaga wybrania wariantu.');

    setCardLoading(button, true, 'Dodaję...');
    const response = await fetch(route('cart/add.js'), {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    });

    if (!response.ok) {
      const payload = await response.json().catch(() => ({}));
      throw new Error(payload?.description || 'Nie udało się dodać produktu.');
    }

    setCardLoading(button, true, 'Dodano ✓');
    setStatus(root, 'Produkt został dodany do koszyka.');
    rememberScroll();
    document.dispatchEvent(new CustomEvent('shopify-event-cart-modified', { detail: { source: 'egifts-cross-sell' } }));
    window.setTimeout(() => window.location.reload(), 500);
  };

  const closeInfoModal = (root) => {
    const modal = root?.querySelector('[data-egifts-cross-sell-modal]');
    if (modal) modal.hidden = true;
    document.body.classList.remove('egifts-cross-sell-modal-open');
    if (lastFocusedElement?.focus) lastFocusedElement.focus({ preventScroll: true });
    lastFocusedElement = null;
  };

  const openInfoModal = (root, productUrl, productTitle, options = {}) => {
    const modal = root.querySelector('[data-egifts-cross-sell-modal]');
    const title = root.querySelector('[data-egifts-cross-sell-modal-title]');
    const infoTitle = root.querySelector('[data-egifts-cross-sell-info-title]');
    const infoText = root.querySelector('[data-egifts-cross-sell-info-text]');
    const link = root.querySelector('[data-egifts-cross-sell-fallback-link]');
    const close = root.querySelector('.egifts-cross-sell-modal__close');

    if (!modal || !link) {
      window.location.assign(productUrl);
      return;
    }

    lastFocusedElement = document.activeElement;
    if (title) title.textContent = productTitle || 'Wybrany produkt';
    if (infoTitle) infoTitle.textContent = options.heading || 'Dokończ personalizację na stronie produktu';
    if (infoText) infoText.textContent = options.message || 'Ten produkt korzysta z kreatora, który działa bezpośrednio na karcie produktu.';
    link.href = productUrl;
    link.textContent = options.button || 'Przejdź do personalizacji';
    modal.hidden = false;
    document.body.classList.add('egifts-cross-sell-modal-open');
    close?.focus({ preventScroll: true });
  };

  const openNativeTeeinblue = async (root, button, productData, fallbackUrl, fallbackTitle) => {
    if (nativeState.opening) return;

    const launcher = root.querySelector('[data-egifts-cross-sell-native-launcher]');
    const parentProductId = String(root.dataset.launcherParentProductId || '');
    nativeState.opening = true;
    setCardLoading(button, true, 'Ładuję...');

    try {
      if (!launcher || !parentProductId || !productData?.productGid) {
        throw new Error('Brak natywnego przycisku Teeinblue.');
      }

      installNativeFetchBridge();
      const trigger = await waitForNativeTrigger(launcher);
      if (!trigger) throw new Error('Teeinblue nie przygotował personalizacji.');

      let baselineCart;
      try {
        baselineCart = await fetchCart();
      } catch (error) {
        baselineCart = { items: [] };
      }
      startNativeArtworkCapture(baselineCart, productData);

      nativeState.active = true;
      nativeState.parentProductId = parentProductId;
      nativeState.targetGid = String(productData.productGid);
      nativeState.expiresAt = Date.now() + 7500;

      trigger.dispatchEvent(new MouseEvent('click', {
        bubbles: true,
        cancelable: true,
        view: window
      }));

      let opened = false;
      for (let attempt = 0; attempt < 120; attempt += 1) {
        if (nativePopupIsOpen()) {
          opened = true;
          break;
        }
        await wait(100);
      }

      if (!opened) throw new Error('Nie udało się otworzyć panelu Teeinblue.');
      const popup = document.querySelector('.tee-cross-sell-product-popup');
      if (popup) {
        popup.dataset.egiftsCrossSellOwned = '1';
        startNativeProductTypeReveal(popup);
      }
      setCardLoading(button, false);
    } catch (error) {
      stopNativeArtworkCapture();
      deactivateNativeBridge();
      setCardLoading(button, false);
      console.warn('[E-GIFTS] Dynamiczny Teeinblue:', error);
      openInfoModal(root, fallbackUrl, fallbackTitle, {
        heading: 'Otwórz personalizację produktu',
        message: 'Nie udało się otworzyć kreatora bezpośrednio w koszyku. Przejdź do produktu i dokończ personalizację na jego stronie.',
        button: 'Przejdź do produktu'
      });
    } finally {
      nativeState.opening = false;
    }
  };

  const openProduct = async (root, button) => {
    if (!root || !button || button.disabled) return;

    const handle = String(button.dataset.productHandle || '');
    const title = String(button.dataset.productTitle || 'Wybrany produkt');
    const url = String(button.dataset.productUrl || route(`products/${handle}`));
    const productId = String(button.dataset.productId || '');
    const productGid = String(button.dataset.productGid || '');
    const personalizer = String(button.dataset.productPersonalizer || '');
    const variantId = String(button.dataset.productVariantId || '');
    const directAdd = button.dataset.productDirectAdd === 'true';
    if (!handle) return;

    setStatus(root, '');
    setCardLoading(button, true, 'Sprawdzam...');

    try {
      const data = productGid && personalizer
        ? { handle, productId, productGid, personalizer, variantId, directAdd, available: true }
        : await getProductData(handle);

      if (data.available === false) throw new Error('Ten produkt jest chwilowo niedostępny.');

      if (data.personalizer === 'teeinblue') {
        await openNativeTeeinblue(root, button, data, url, title);
      } else if (data.personalizer === 'customily') {
        setCardLoading(button, false);
        openInfoModal(root, url, title, {
          heading: 'Otwórz kreator produktu',
          message: 'Kreator tego produktu wymaga otwarcia jego karty. Produkty, które masz już w koszyku, pozostaną bez zmian.',
          button: 'Przejdź do personalizacji'
        });
      } else if (data.directAdd === true && data.variantId) {
        await addDirectlyToCart(root, button, data);
      } else {
        setCardLoading(button, false);
        window.location.assign(url);
      }
    } catch (error) {
      setCardLoading(button, false, 'Spróbuj ponownie');
      setStatus(root, error?.message || 'Nie udało się otworzyć produktu.');
      window.setTimeout(() => setCardLoading(button, false), 2200);
    }
  };

  const loadRoot = async (root) => {
    if (!root || root.dataset.egiftsCrossSellLoading === 'true') return;
    root.dataset.egiftsCrossSellLoading = 'true';

    try {
      const prepared = await prepareRandomStorePool(root);
      if (!prepared.pool.length) throw new Error('Brak produktów do pokazania.');
      setPool(root, 'random', prepared.pool, { mode: 'random', activate: false });
      if (!root._egiftsActiveCategory || root._egiftsActiveCategory === 'random') {
        activateCategory(root, 'random');
        renderActivePool(root, false);
      } else {
        updateShuffleButton(root);
      }
      root.dataset.egiftsCrossSellReady = 'true';
      hydrateRandomStorePool(root, prepared).catch(() => {});
    } catch (error) {
      console.warn('[E-GIFTS] Losowy cross-sell:', error);
      root.hidden = true;
    } finally {
      delete root.dataset.egiftsCrossSellLoading;
    }
  };

  const observeRoot = (root) => {
    if (observedRoots.has(root)) return;
    observedRoots.add(root);
    delete root.dataset.egiftsCrossSellLoading;
    root.dataset.egiftsCrossSellObserved = 'true';

    if (!('IntersectionObserver' in window)) {
      loadRoot(root);
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      if (!entries.some((entry) => entry.isIntersecting)) return;
      observer.disconnect();
      loadRoot(root);
    }, { rootMargin: '450px 0px' });

    observer.observe(root);
  };

  const initAll = (scope = document) => {
    const roots = Array.from(scope.querySelectorAll(ROOT_SELECTOR));
    if (scope.matches?.(ROOT_SELECTOR)) roots.unshift(scope);
    roots.forEach((root) => {
      if (!root.isConnected) return;
      const key = String(root.dataset.sectionId || 'cart');
      const existing = liveRoots.get(key);
      if (existing?.isConnected && existing !== root) {
        if (existing.contains(root) || existing.getClientRects().length) {
          root.remove();
          return;
        }
        existing.remove();
      }
      liveRoots.set(key, root);
      placeRoot(root);
      observeRoot(root);
    });
  };
  const rootObserver = new MutationObserver((records) => {
    records.forEach((record) => {
      record.addedNodes.forEach((node) => {
        if (node.nodeType === 1 && (node.matches(ROOT_SELECTOR) || node.querySelector(ROOT_SELECTOR))) {
          initAll(node);
        }
      });
    });
  });
  const watchRoots = () => {
    rootObserver.observe(document.body, { childList: true, subtree: true });
  };
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchRoots, { once: true });
  } else {
    watchRoots();
  }


  const refreshSection = async () => {
    if (refreshInFlight) {
      refreshQueued = true;
      return;
    }
    if (Date.now() < nativeState.suppressRefreshUntil || nativeState.opening) return;

    const oldRoot = document.querySelector(ROOT_SELECTOR);
    const modal = oldRoot?.querySelector('[data-egifts-cross-sell-modal]');
    if (modal && !modal.hidden) return;

    const sectionId = oldRoot?.dataset.sectionId || crossSellSectionId;
    if (!sectionId) return;

    refreshInFlight = true;
    try {
      const response = await fetch(`${route('cart')}?section_id=${encodeURIComponent(sectionId)}`, {
        headers: { Accept: 'text/html' },
        cache: 'no-store'
      });
      if (!response.ok) return;

      const text = await response.text();
      const html = new DOMParser().parseFromString(text, 'text/html');
      const newRoot = html.querySelector(ROOT_SELECTOR);

      const currentRoot = Array.from(document.querySelectorAll(ROOT_SELECTOR))
        .find((root) => root.dataset.sectionId === sectionId);
      if (Date.now() < nativeState.suppressRefreshUntil || nativeState.opening) return;
      const currentModal = currentRoot?.querySelector('[data-egifts-cross-sell-modal]');
      if (currentModal && !currentModal.hidden) return;
      if (!newRoot) {
        if (currentRoot) currentRoot.hidden = true;
        return;
      }

      if (currentRoot) {
        currentRoot.replaceWith(newRoot);
      } else {
        const host = crossSellSectionHost
          || document.getElementById(`shopify-section-${sectionId}`)
          || document.body;
        host.append(newRoot);
      }

      placeRoot(newRoot);
      initAll(document);
      nativeState.suppressRefreshUntil = Date.now() + 1200;
      document.dispatchEvent(new Event('shopify-event-cart-ajax'));
    } catch (error) {
      console.warn('[E-GIFTS] Odświeżenie cross-sellu:', error);
    } finally {
      refreshInFlight = false;
      if (refreshQueued) {
        refreshQueued = false;
        window.clearTimeout(refreshTimer);
        const delay = Math.max(0, nativeState.suppressRefreshUntil - Date.now()) + 20;
        refreshTimer = window.setTimeout(refreshSection, delay);
      }
    }
  };

  const scheduleRefresh = (delay = 500) => {
    if (Date.now() < nativeState.suppressRefreshUntil || nativeState.opening) return;
    if (refreshInFlight) {
      refreshQueued = true;
      return;
    }
    window.clearTimeout(refreshTimer);
    refreshTimer = window.setTimeout(refreshSection, delay);
  };

  // Łapiemy finalny artwork już na pointerdown przycisku ATC w popupie.
  // To dzieje się zanim Teeinblue zdąży zamknąć/odmontować podgląd.
  document.addEventListener('pointerdown', (event) => {
    const ownedTeePopup = event.target.closest?.('.tee-cross-sell-product-popup[data-egifts-cross-sell-owned="1"]');
    if (!ownedTeePopup) return;

    const atc = event.target.closest?.('.tee-btn--atc, [class*="tee-btn"][class*="atc"], button[type="submit"]');
    if (!atc) return;

    armIndependentNativeAdd();
    captureNativeArtworkNow();
    window.setTimeout(captureNativeArtworkNow, 30);
    window.setTimeout(captureNativeArtworkNow, 90);
    window.setTimeout(persistNativeArtworkAndRefresh, 40);
  }, true);

  document.addEventListener('click', (event) => {
    const ownedTeePopup = event.target.closest?.('.tee-cross-sell-product-popup[data-egifts-cross-sell-owned="1"]');
    if (ownedTeePopup) {
      if (event.target.closest?.('.tee-btn--atc, [class*="tee-btn"][class*="atc"], button[type="submit"]')) {
        armIndependentNativeAdd();
        captureNativeArtworkNow();
      }
      window.setTimeout(() => revealNativeProductType(ownedTeePopup), 0);
      window.setTimeout(() => revealNativeProductType(ownedTeePopup), 80);
    }

    const categoryShuffle = event.target.closest?.('[data-egifts-cross-sell-category-shuffle]');
    if (categoryShuffle) {
      const root = categoryShuffle.closest(ROOT_SELECTOR);
      if (!root || categoryShuffle.disabled) return;
      event.preventDefault();
      renderActivePool(root, true);
      return;
    }

    const shuffle = event.target.closest?.('[data-egifts-cross-sell-shuffle]');
    if (shuffle) {
      const root = shuffle.closest(ROOT_SELECTOR);
      if (!root || shuffle.disabled) return;
      event.preventDefault();

      const states = ensurePoolStates(root);
      if (!states.has('random')) return;
      activateCategory(root, 'random');
      renderActivePool(root, true);
      return;
    }

    const category = event.target.closest?.('[data-egifts-cross-sell-category]');
    if (category) {
      const root = category.closest(ROOT_SELECTOR);
      if (!root || category.disabled) return;
      event.preventDefault();

      const key = String(category.dataset.egiftsCrossSellCategory || 'random');
      const states = ensurePoolStates(root);

      if (states.has(key)) {
        activateCategory(root, key);
        renderActivePool(root, false);
        return;
      }

      if (key === 'random') return;

      activateCategory(root, key);
      category.disabled = true;
      setStatus(root, '');
      loadCategoryCandidates(root, key)
        .then((products) => {
          if (!products.length) {
            if (root._egiftsActiveCategory === key) {
              setStatus(root, 'W tej kategorii nie znaleźliśmy teraz dostępnych produktów.');
            }
            return;
          }
          const mode = key === 'newest' || (CATEGORY_COLLECTIONS[key] || []).length > 1 ? 'ordered' : 'random';
          setPool(root, key, products, { mode, activate: false });
          if (root._egiftsActiveCategory === key) renderActivePool(root, false);
        })
        .catch(() => {
          if (root._egiftsActiveCategory === key) {
            setStatus(root, 'Nie udało się wczytać tej kategorii. Spróbuj ponownie.');
          }
        })
        .finally(() => { category.disabled = false; });
      return;
    }

    const previous = event.target.closest?.('[data-egifts-cross-sell-prev]');
    const next = event.target.closest?.('[data-egifts-cross-sell-next]');
    if (previous || next) {
      const root = (previous || next).closest(ROOT_SELECTOR);
      if (!root) return;
      event.preventDefault();
      scrollCarousel(root, next ? 1 : -1);
      return;
    }

    const open = event.target.closest?.('[data-egifts-cross-sell-open]');
    if (open) {
      const root = open.closest(ROOT_SELECTOR);
      if (!root) return;
      event.preventDefault();
      openProduct(root, open);
      return;
    }

    const close = event.target.closest?.('[data-egifts-cross-sell-close]');
    if (close) {
      const root = close.closest(ROOT_SELECTOR);
      if (!root) return;
      event.preventDefault();
      closeInfoModal(root);
    }
  }, true);

  document.addEventListener('change', (event) => {
    const ownedTeePopup = event.target.closest?.('.tee-cross-sell-product-popup[data-egifts-cross-sell-owned="1"]');
    if (!ownedTeePopup) return;
    window.setTimeout(captureNativeArtworkNow, 20);
    window.setTimeout(captureNativeArtworkNow, 140);
    window.setTimeout(() => revealNativeProductType(ownedTeePopup), 0);
    window.setTimeout(() => revealNativeProductType(ownedTeePopup), 100);
  }, true);

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const root = document.querySelector(ROOT_SELECTOR);
    const modal = root?.querySelector('[data-egifts-cross-sell-modal]');
    if (modal && !modal.hidden) closeInfoModal(root);
  });

  document.addEventListener('shopify-event-cart-ajax', () => scheduleRefresh(650));
  document.addEventListener('shopify-event-cart-modified', () => scheduleRefresh(650));
  document.addEventListener('egifts:g-promo-synced', () => scheduleRefresh(650));
  // Różne wersje SDK Teeinblue używają różnych nazw eventu po dodaniu.
  // Wszystkie kierujemy do jednego, zabezpieczonego przed duplikacją zapisu.
  document.addEventListener('teeinblue-event-after-cart-added', persistNativeArtworkAndRefresh);
  document.addEventListener('teeinblue:added-to-cart', persistNativeArtworkAndRefresh);
  document.addEventListener('tee:added-to-cart', persistNativeArtworkAndRefresh);

  if (typeof placementMedia.addEventListener === 'function') {
    placementMedia.addEventListener('change', schedulePlacement);
  } else if (typeof placementMedia.addListener === 'function') {
    placementMedia.addListener(schedulePlacement);
  }
  window.addEventListener('resize', schedulePlacement, { passive: true });
  window.addEventListener('pagehide', () => {
    stopNativeArtworkCapture();
    stopNativeProductTypeReveal();
  });

  const restoreScroll = () => {
    let value = '';
    try {
      value = window.sessionStorage.getItem('egifts-cross-sell-scroll') || '';
      if (value) window.sessionStorage.removeItem('egifts-cross-sell-scroll');
    } catch (error) {}

    if (!value) return;
    const top = Number(value);
    if (!Number.isFinite(top)) return;
    window.setTimeout(() => window.scrollTo({ top, left: 0, behavior: 'auto' }), 80);
    window.setTimeout(() => window.scrollTo({ top, left: 0, behavior: 'auto' }), 320);
  };

  window.EgiftsCartCrossSell = { version: VERSION, initAll, refresh: scheduleRefresh };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initAll();
      restoreScroll();
    }, { once: true });
  } else {
    initAll();
    restoreScroll();
  }
})();